import React from "react";

import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type QuickActionCardProps = {
	icon: IconDefinition;
	label: string;
	onClick: () => void;
	"data-testid"?: string;
};

/** Empty-state quick action; onClick sends the card's query through the agent stream. */
export const QuickActionCard: React.FC<QuickActionCardProps> = ({
	icon,
	label,
	onClick,
	"data-testid": dataTestId,
}) => (
	<button
		type="button"
		data-testid={dataTestId}
		onClick={onClick}
		className="box-border flex h-24 cursor-pointer flex-col items-start gap-2 rounded-lg border border-solid border-neutral-2 bg-white px-3 py-4 text-left font-[inherit] transition-colors hover:border-primary-2 hover:bg-primary-1 active:border-primary-5 active:bg-primary-1"
	>
		<FontAwesomeIcon icon={icon} className="h-6 w-6 text-primary-5" />
		<span className="text-sm leading-4 font-normal text-primary-5">{label}</span>
	</button>
);

export default QuickActionCard;
